// Vitals subsection form field enum
export enum VitalsFormField {
  VITALS_TEMPERATURE = 'medical-background/vitals/temperature',
  VITALS_PULSE = 'medical-background/vitals/pulse',
  VITALS_RESPIRATIONS = 'medical-background/vitals/respirations',
  VITALS_O2_SATURATION = 'medical-background/vitals/o2-saturation',
  VITALS_BLOOD_PRESSURE = 'medical-background/vitals/blood-pressure',
  VITALS_HEIGHT = 'medical-background/vitals/height',
  VITALS_BLOOD_SUGAR = 'medical-background/vitals/blood-sugar',
  VITALS_WEIGHT = 'medical-background/vitals/weight'
}
